"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
var formik_1 = require("formik");
var hooks_1 = require("preact/hooks");
var Button_1 = require("react-bootstrap/Button");
var OverlayTrigger_1 = require("react-bootstrap/OverlayTrigger");
var Text = function (_props) {
    var _a, _b;
    var label = _props.label, help = _props.help, className = _props.className, inputClass = _props.inputClass, helpPopover = _props.helpPopover, props = __rest(_props, ["label", "help", "className", "inputClass", "helpPopover"]);
    var _c = (0, formik_1.useField)(props), field = _c[0], meta = _c[1];
    // Show inline feedback if EITHER
    // - the input is focused AND value is longer than 2 characters
    // - or, the has been visited (touched === true)
    var _d = (0, hooks_1.useState)(false), didFocus = _d[0], setDidFocus = _d[1];
    var handleFocus = function () { return setDidFocus(true); };
    var showFeedback = (!!didFocus && ((_b = (_a = String(field.value)) === null || _a === void 0 ? void 0 : _a.trim()) === null || _b === void 0 ? void 0 : _b.length) > 2) || meta.touched;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "form-group ".concat(className !== null && className !== void 0 ? className : '', " ").concat(showFeedback ? (meta.error ? "invalid" : "valid") : "") }, { children: [(0, jsx_runtime_1.jsx)("label", __assign({ htmlFor: props.id }, { children: label })), (helpPopover && helpPopover.overlay) &&
                (0, jsx_runtime_1.jsx)(OverlayTrigger_1.default, __assign({ trigger: helpPopover.trigger, placement: helpPopover.placement, overlay: helpPopover.overlay }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ variant: "link", size: "sm", className: "help-button" }, { children: (0, jsx_runtime_1.jsx)("i", { className: "icon-question" }) })) })), (0, jsx_runtime_1.jsx)("input", __assign({ className: "form-control ".concat(inputClass) }, props, field, { "aria-describedby": "".concat(props.id, "-feedback ").concat(props.id, "-help"), onFocus: handleFocus })), help && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "text-xs", id: "".concat(props.id, "-help"), tabIndex: -1 }, { children: help })))] })));
};
exports.default = Text;
